// extracted by mini-css-extract-plugin
export default {"error":"TextError_error__hvNEG"};